import { useReactiveVar } from '@apollo/client'
import {
  LocalGridFragment,
  LocalGridType,
  ProviderFragment,
  ProviderType,
} from '../generated/graphql'
import { activeVersionVar } from '../apollo/reactive-vars'
import { localGridTypeToProviderTypeMap } from './local-grid-util'
import { EnergyType } from '../calculators/EnergyFlow'

type LocalGridUtil = {
  providerType: ProviderType
  allLocalGrids: LocalGridFragment[]
  waterGrid?: LocalGridFragment
  connectedWaterGridProvider?: ProviderFragment
  isWaterGridConnected: boolean
  availableEnergyTypes: EnergyType[]
}

export const useLocalGridUtil = (
  localGrid: LocalGridFragment,
): LocalGridUtil => {
  const activeVersion = useReactiveVar(activeVersionVar)

  const providerType = localGridTypeToProviderTypeMap[localGrid.type]

  const allLocalGrids = activeVersion?.localGrids ?? []
  const waterGrid = allLocalGrids.find((lg) => lg.type === LocalGridType.Water)
  const connectedWaterGridProvider = waterGrid?.providers.find(
    (provider) => provider.type === providerType,
  )
  const isWaterGridConnected = connectedWaterGridProvider !== undefined

  const availableEnergyTypes =
    localGrid.type === LocalGridType.Electricity
      ? [EnergyType.Electricity]
      : [EnergyType.Heating, EnergyType.Cooling]

  return {
    providerType,
    allLocalGrids,
    waterGrid,
    connectedWaterGridProvider,
    isWaterGridConnected,
    availableEnergyTypes,
  }
}
